import type { FC } from 'react';

interface CarouselItem {
  tag: string;
  title: string;
  desc: string;
  imageUrl: string;
  alt: string;
}

const carouselData: CarouselItem[] = [
  {
    tag: '明星八卦',
    title: '娱乐圈最新爆料合集',
    desc: '一线明星私密视频独家曝光，最新绯闻追踪全程记录，热门黑料视频一网打尽不遗漏。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photograph%20of%20a%20glamorous%20red%20carpet%20event%20scene%20with%20paparazzi%20camera%20flashes%2C%20warm%20spotlight%20dramatic%20lighting%2C%20luxurious%20atmosphere%20with%20velvet%20curtains%2C%20dark%20cinematic%20background%20with%20golden%20accents%2C%20mysterious%20mood%20photography%20style%2C%20rich%20crimson%20and%20amber%20color%20palette%2C%20soft%20bokeh%20effects%2C%20editorial%20quality&width=600&height=400&seq=carousel-01&orientation=landscape',
    alt: '娱乐圈最新爆料合集 - 黑料视频明星八卦专区',
  },
  {
    tag: '网红追踪',
    title: '网红圈内幕深扒系列',
    desc: '当红主播与短视频达人背后故事全揭秘，网红黑料视频合集每日追更不停歇。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylish%20modern%20streaming%20studio%20setup%20with%20professional%20ring%20light%20and%20camera%20equipment%2C%20warm%20ambient%20lighting%20with%20neon%20accents%2C%20dark%20moody%20atmosphere%20with%20subtle%20crimson%20glow%2C%20premium%20production%20setup%20against%20dark%20backdrop%2C%20cinematic%20composition%20with%20dramatic%20shadows%2C%20editorial%20photography%20quality&width=600&height=400&seq=carousel-02&orientation=landscape',
    alt: '网红圈内幕深扒系列 - 黑料视频网红追踪',
  },
  {
    tag: '社会热点',
    title: '社会事件深度追踪报道',
    desc: '焦点新闻背后的黑料真相揭秘，社会热点视频第一时间采集更新，随时掌握最新动态。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20urban%20night%20scene%20with%20city%20lights%20and%20breaking%20news%20ambience%2C%20warm%20streetlight%20glow%20against%20dark%20skyline%2C%20atmospheric%20fog%20and%20dramatic%20shadows%2C%20cinematic%20wide%20shot%20with%20rich%20crimson%20and%20amber%20tone%20grading%2C%20moody%20editorial%20photography%20style%2C%20professional%20composition&width=600&height=400&seq=carousel-03&orientation=landscape',
    alt: '社会事件深度追踪报道 - 黑料视频社会热点',
  },
  {
    tag: '独家首发',
    title: '平台独家爆料第一时间',
    desc: '全网最快的黑料视频发布速度，独家来源精准核实，重磅爆料内容只在黑料视频平台。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20exclusive%20investigative%20scene%20with%20documents%20and%20digital%20screens%20displaying%20abstract%20data%2C%20warm%20desk%20lamp%20lighting%20creating%20dramatic%20shadows%2C%20dark%20premium%20office%20atmosphere%20with%20leather%20and%20wood%20textures%2C%20cinematic%20composition%20with%20rich%20crimson%20accents%2C%20editorial%20photography%20quality&width=600&height=400&seq=carousel-04&orientation=landscape',
    alt: '平台独家爆料第一时间 - 黑料视频独家首发',
  },
  {
    tag: '国产专区',
    title: '国产黑料视频精品合集',
    desc: '91黑料视频国产专区每周更新精选内容，高清画质免费在线观看，支持一键下载收藏。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20curated%20premium%20content%20library%20display%20with%20elegant%20dark%20shelves%20and%20warm%20accent%20lighting%2C%20luxurious%20private%20cinema%20atmosphere%20with%20velvet%20textures%2C%20soft%20golden%20spotlights%2C%20rich%20crimson%20and%20dark%20amber%20color%20palette%2C%20sophisticated%20editorial%20interior%20photography%2C%20premium%20composition&width=600&height=400&seq=carousel-05&orientation=landscape',
    alt: '国产黑料视频精品合集 - 黑料视频国产专区',
  },
];

const aboutContent = {
  title: '关于黑料视频',
  paragraphs: [
    '黑料视频是国内领先的黑料视频聚合平台，专注于为观众提供最新、最全、最高清的国产黑料视频内容。我们从全网海量资源中精准筛选，每日更新数千条热门黑料视频，覆盖娱乐八卦、网红内幕、社会热点等多个垂直领域。平台采用先进的视频分发技术，确保每一位用户都能享受流畅、无卡顿的在线观看体验。',
    '我们深知用户对内容真实性和时效性的追求，因此黑料视频建立了严格的内容审核与更新机制，所有视频均经过多重核验后上架。无论是91黑料视频的老用户，还是首次接触黑料视频的新观众，都能在这里找到自己感兴趣的内容，并通过便捷的下载功能随时随地观看。',
    '黑料视频不仅仅是视频播放平台，更是一个汇聚同好的内容社区。我们持续优化国产专区的内容结构，不断丰富热门黑料视频合集，致力于成为用户获取黑料资讯和视频内容的首选目的地。',
  ],
};

interface TopicItem {
  icon: string;
  label: string;
  count: string;
  hot: boolean;
}

const topicsData: TopicItem[] = [
  { icon: 'ri-fire-line', label: '明星黑料', count: '23.6万', hot: true },
  { icon: 'ri-live-line', label: '网红爆料', count: '18.2万', hot: true },
  { icon: 'ri-vidicon-line', label: '国产视频', count: '31.4万', hot: true },
  { icon: 'ri-flashlight-line', label: '独家首发', count: '12.8万', hot: false },
  { icon: 'ri-bar-chart-grouped-line', label: '热议排行', count: '9.5万', hot: true },
  { icon: 'ri-movie-line', label: '91黑料视频', count: '27.1万', hot: true },
  { icon: 'ri-shield-flash-line', label: '内幕深扒', count: '15.3万', hot: false },
  { icon: 'ri-newspaper-line', label: '资讯速递', count: '8.7万', hot: false },
  { icon: 'ri-download-cloud-line', label: '下载专区', count: '20.9万', hot: true },
];

interface FaqItem {
  q: string;
  a: string;
}

const faqData: FaqItem[] = [
  {
    q: '黑料视频平台的内容多久更新一次？',
    a: '黑料视频每日24小时不间断更新，平均每天新增超过12,000条热门黑料视频内容。我们的编辑团队全天候监控全网热点，确保用户第一时间看到最新爆料和独家内容。国产专区每周定期整理精品合集，方便用户批量观看和下载。',
  },
  {
    q: '如何在黑料视频观看和下载视频？',
    a: '访问黑料视频官网即可直接在线观看所有国产黑料视频内容，无需注册或付费。平台支持高清流畅播放，并为一键下载功能提供便捷入口。无论是91黑料视频专区还是热门黑料视频合集，所有内容均可免费获取，随时随地享受观影体验。',
  },
  {
    q: '平台上的视频内容是否经过审核？',
    a: '是的，黑料视频对平台所有内容实行严格的多重审核机制。每一条视频在上架前都经过自动化检测与人工复核，确保内容真实可靠、来源清晰。我们致力于为用户提供高质量、可信任的黑料视频内容，同时持续优化内容筛选标准。',
  },
  {
    q: '如何联系平台进行投稿或反馈？',
    a: '您可以通过黑料视频官网的联系我们页面提交投稿内容或反馈意见。我们欢迎用户提供有价值的视频线索和独家爆料素材，审核通过后将第一时间在平台发布并标注来源。对于平台使用过程中遇到的任何问题，也可随时通过联系通道与我们沟通。',
  },
];

const CarouselSection: FC = () => (
  <section id="carousel" className="relative w-full py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          焦点专题
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
          精选热门黑料视频专题，一站式浏览最新最热的国产黑料内容
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 md:gap-6">
        {carouselData.map((item, idx) => (
          <article
            key={idx}
            className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
          >
            <div className="relative aspect-[3/2] overflow-hidden">
              <img
                src={item.imageUrl}
                alt={item.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading={idx < 2 ? undefined : 'lazy'}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                {item.tag}
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-base font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {item.desc}
              </p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

const AboutSection: FC = () => (
  <section id="about" className="relative w-full py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          {aboutContent.title}
        </h2>
        <div className="mt-8 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          {aboutContent.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </div>
    </div>
  </section>
);

const TopicsSection: FC = () => (
  <section id="topics" className="relative w-full py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          热门话题
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
          当前最受关注的黑料视频话题标签，点击探索感兴趣的内容方向
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4 max-w-4xl mx-auto">
        {topicsData.map((topic) => (
          <a
            key={topic.label}
            href={`#topics`}
            className="flex items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer group"
          >
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors shrink-0">
              <i className={`${topic.icon} text-lg md:text-xl`}></i>
            </div>
            <div className="min-w-0">
              <div className="flex items-center gap-1.5">
                <span className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                  {topic.label}
                </span>
                {topic.hot && (
                  <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 text-[10px] font-bold whitespace-nowrap">
                    HOT
                  </span>
                )}
              </div>
              <span className="text-xs text-foreground-500">{topic.count} 条内容</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

const FaqSection: FC = () => (
  <section id="faq" className="relative w-full py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          常见问答
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
          关于黑料视频平台的常见问题与解答，快速了解平台功能与使用方式
        </p>
      </div>
      <div className="max-w-3xl mx-auto grid gap-4">
        {faqData.map((item, idx) => (
          <details key={idx} className="group border border-background-200/60 rounded-xl overflow-hidden" open={idx === 0}>
            <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer bg-background-50 hover:bg-background-100 transition-colors list-none">
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 pr-4">
                {item.q}
              </h3>
              <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 group-open:rotate-45 transition-transform">
                <i className="ri-add-line"></i>
              </span>
            </summary>
            <div className="px-5 md:px-6 pb-5 md:pb-6">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.a}
              </p>
            </div>
          </details>
        ))}
      </div>
    </div>
  </section>
);

const AppSection: FC = () => (
  <section id="app" className="relative w-full py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14 max-w-4xl mx-auto">
        <div className="flex-1 text-center lg:text-left">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            移动端入口
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            黑料视频移动端适配已全面上线，在手机浏览器中访问即可获得与桌面端一致的高清流畅观看体验。无需下载安装，打开即看，随时随地追踪最新国产黑料视频内容。支持一键收藏与离线缓存，让热门黑料视频永不缺席。
          </p>
          <div className="mt-6 flex flex-wrap gap-3 justify-center lg:justify-start">
            <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-foreground-950 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap">
              <i className="ri-android-line"></i>
              Android 访问
            </span>
            <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-foreground-950 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap">
              <i className="ri-apple-line"></i>
              iOS 访问
            </span>
          </div>
        </div>
        <div className="flex-1 w-full max-w-sm">
          <div className="relative">
            <div className="absolute -inset-3 bg-gradient-to-br from-primary-200/30 to-accent-200/20 rounded-2xl blur-lg"></div>
            <div className="relative rounded-2xl overflow-hidden border border-background-200/60 aspect-[9/16] max-w-[240px] mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20stylish%20dark%20theme%20video%20content%20app%20interface%20with%20thumbnail%20grid%20layout%2C%20warm%20crimson%20and%20amber%20accent%20colors%2C%20premium%20UI%20design%20with%20sleek%20cards%2C%20luxurious%20dark%20background%2C%20editorial%20product%20photography%20with%20soft%20studio%20lighting&width=480&height=854&seq=app-mobile-mockup&orientation=portrait"
                alt="黑料视频移动端界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default function SectionsPart1() {
  return (
    <>
      <CarouselSection />
      <AboutSection />
      <TopicsSection />
      <FaqSection />
      <AppSection />
    </>
  );
}